import styled from 'styled-components';

export const MainGrid = styled.div`
  display: flex;
  height: 100vh;
  .imgsPart {
    background-color: var(--beige);
  }
`;

export const FlexItemContent = styled.div`
  display: flex;
  width: ${(props) => (props.isBig ? props.bigWidth : 'calc(50% - 1rem)')};
`;

export const ContentBox = styled.div`
  margin: 1rem;

  width: calc(100% - 162px);
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  & > div {
    height: ${(props) => (props.isBig ? '100%' : 'calc(50% - 1rem)')};
    overflow: hidden;
    overflow-y: hidden;
    overflow-y: scroll;
    .gatsby-image-wrapper {
      width: ${(props) => (props.isBig ? '100%' : '')};
      height: ${(props) => (props.isBig ? '' : '100%')};
      object-fit: contain;
    }
  }

  .imageBox {
    scroll-snap-type: y mandatory;

    .gatsby-image-wrapper {
      scroll-snap-align: start;
    }
  }

  .imgLink {
    max-width: 9.3rem;
  }

  .nav-links {
    font-size: 1.2rem;
    line-height: 1.4rem;
    a {
      opacity: var(--opacity);
      &[aria-current='page'] {
        color: var(--focus);
      }
    }
  }

  p {
    line-height: 1.3rem;
  }
`;
